import template from './new.html';
import { property } from 'lodash-es';
import { date } from '../../../../../helpers';
import {
  ITEM_KINDS,
  STATES,
  MOVE_DATE_MIN,
  ITEM_DEFINITION_CODES,
} from '../../../../../constants';
import { actions, selectors } from '../../../../../state';
import './new.global.css';
import { trackEngagement } from '@mover-app/engagement';

const getResponseId = property('meta.response.data.data.id');

const MESSAGES = {
  SUCCESS: 'Your mail forwarding form has been submitted!',
  ERROR: 'Sorry. There was an error submitting your form. Please try again.',
};

class ForwardMailNewController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    const { connect, getState } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);

    // Not using connect since this is being connected to a form
    this.item = getItemFromState(getState());
  }

  $onDestroy() {
    this.disconnect && this.disconnect();
  }

  get cancelSref() {
    return this.hasForwardMailItems
      ? STATES.STEP_FORWARD_MAIL_LIST
      : STATES.DASHBOARD;
  }

  goToNextStep() {
    const nextStep = selectors.step.nextStep(this.updStore.getState());
    this.updStore.dispatch(actions.step.goToNext(nextStep));
  }

  onSubmit(item) {
    const { dispatch } = this.updStore;
    trackEngagement({
      name: 'Forward Mail',
      code: ITEM_DEFINITION_CODES.FORWARD_MAIL,
      trigger: 'form',
    });

    const success = (response) => {
      // Manually decide to move to list or verify for now
      // TODO: Revisit this since we should be able to do it
      //       via angular-roles, but we would have to make
      //       another call to get the updated Move. Review
      //       once the verify components are refactored.
      if (this.isMoveVerified) {
        dispatch(actions.router.stateGo(STATES.STEP_FORWARD_MAIL_LIST));
        dispatch(actions.message.success(MESSAGES.SUCCESS));
      } else {
        dispatch(actions.router.stateGo(STATES.STEP_FORWARD_MAIL_VERIFY));
      }
      dispatch(
        actions.analytics.track('Submitted FYM', {
          id: getResponseId(response),
        })
      );
    };

    const error = (response) => {
      dispatch(actions.message.error(MESSAGES.ERROR));
      dispatch(actions.analytics.track('Tried to Submit FYM', response));
    };

    dispatch(
      actions.item.create({
        ...item,
        move_id: this.moveId,
        kind: ITEM_KINDS.FORWARD_MAIL,
      })
    ).then(success, error);
  }
}

export const ForwardMailNewComponent = {
  template,
  controller: ForwardMailNewController,
};

function getItemFromState(state) {
  const move = selectors.current.move(state);
  const startDate = move.date(state);

  return {
    from_address: move.fromAddress(state),
    to_address: move.toAddress(state),

    // If the start date is too far in the past set to today
    start_date:
      date.stringToDate(startDate) < MOVE_DATE_MIN
        ? date.toIso8601()
        : startDate,
  };
}

function mapStateToThis(state) {
  const move = selectors.current.move(state);

  return {
    moveId: move.id(state),
    hasForwardMailItems: selectors.current.hasForwardMailItems(state),
    submitting: selectors.pending.match(actions.item.isCreate, state),
    isMoveVerified: move.isVerified(state),
  };
}
